import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import Grid from "@mui/system/Unstable_Grid/Grid";
import { Card } from "react-bootstrap";
import PropTypes from "prop-types";
import ProgressDoughnutChart from "examples/Charts/DoughnutCharts/ProgressDoughnutChart";
import axios from "axios";
import Select from "react-select";
import SoftInput from "components/SoftInput";
import SoftBadge from "components/SoftBadge";
import {
  TextField,
  Box,
  Grid as MuiGrid,
  Button,
  Typography,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import editicon from "../../assets/images/message-edit.png";
import Swal from "sweetalert2";
import refreshBtn from "../../assets/images/refresh_btn.png";
import { useNavigate } from "react-router-dom";
import PostProfile from "../../Jobprovider/layout/postProfile";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import noDataImg from "../../../src/assets/images/browser.png";
import refresh from "../../../src/assets/images/refresh.png";
import edit from "../../../src/assets/images/edit.png";
import profile from "../../../src/assets/images/profile-add.png";
import { display, maxWidth } from "@mui/system";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import SquareIcon from "@mui/icons-material/Square";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { useTheme } from "@mui/material/styles";
import "./ProfileCSS.css";
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Doughnut } from "react-chartjs-2";
import { ResponsivePie } from "@nivo/pie";
import {
  BoxButtonContainer,
  BoxCompanyInfo,
  BoxGrid1,
  BoxImg,
  BoxMain1,
  BoxMain2,
  BoxMain3,
  TypographyCompanyDes,
  TypographyCompanyinfo,
  TypographyLocation,
  TypographyOrg1,
  TabButtonLeft,
  TabButtonClickLeft,
  TabButton,
  TabButtonClick,
  BoxHeadingContainer1,
  TypographyTabHeading,
  BoxInfoContainer1,
  BoxHeading1,
  TypographyHeading1,
  TypographyList,
  TypographyHeading2,
  BoxFlex1,
} from "./Style";
import locationicon from "../../assets/images/location1.png";
import editiconimg from "../../assets/images/edit-2.png";
import hiring1img from "../../assets/images/human-resources 2.png";
import hiring2img from "../../assets/images/suitcase (3) 1.png";
import spocimg from "../../assets/images/user (9) 1.png";
import cmpimg from "../../assets/images/business-and-trade (3) 1.png";
ChartJS.register(ArcElement, Tooltip, Legend);
import { useRef } from 'react';

const ProfilePage = (props) => {
  const [step, setStep] = useState(0);

  const [editOne, setEditOne] = useState(false);
  const [editTwo, setEditTwo] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const matchlg = useMediaQuery(theme.breakpoints.up("lg"));
  const matchmd = useMediaQuery(theme.breakpoints.up("md"));
  const matchsm = useMediaQuery(theme.breakpoints.up("sm"));
  const data = [
    {
      id: "ruby",
      label: "ruby",
      value: 171,
      color: "hsl(174, 70%, 50%)",
    },
    // {
    //   id: "erlang",
    //   label: "erlang",
    //   value: 160,
    //   color: "hsl(193, 70%, 50%)",
    // },
    // {
    //   id: "python",
    //   label: "python",
    //   value: 560,
    //   color: "hsl(80, 70%, 50%)",
    // },
    // {
    //   id: "elixir",
    //   label: "elixir",
    //   value: 291,
    //   color: "hsl(112, 70%, 50%)",
    // },
    {
      id: "lisp",
      label: "lisp",
      value: 424,
      color: "hsl(48, 70%, 50%)",
    },
  ];
  const searchInOption = [
    { label: "Last 15 days", value: "15" },
    { label: "Last 30 days", value: "30" },
    { label: "Last 60 days", value: "60" },
  ];

  const industry = [
    { label: "Textile and Clothing", value: "Textile and Clothing" },
    { label: "Building and Construction", value: "Building and Construction" },
    { label: "Automobile and Transportation", value: "Automobile and Transportation" },
    { label: "Organized and Unorganized Retail", value: "Organized and Unorganized Retail" },
    { label: "Gems and Jewellery", value: "Gems and Jewellery" },
    { label: "IT & Computers", value: "IT & Computers" },
    { label: "Furniture and Furnishing", value: "Furniture and Furnishing" },
    { label: "Healthcare", value: "Healthcare" },
    { label: "Leather and Leather Goods", value: "Leather and Leather Goods" },
    { label: "Tourism and Hospitality", value: "Tourism and Hospitality" },
    { label: "Agriculture", value: "Agriculture" },
    { label: "Mining", value: "Mining" },
    { label: "Households", value: "Households" },
    { label: "Media and Entertainment", value: "Media and Entertainment" },
  ];

  const cpId = sessionStorage.getItem("register_id");
  const cpType = sessionStorage.getItem("cp_type");
  const [details, setDetails] = useState({});
  const [serachIn, setSearchIn] = useState("15");
  const [showEditProfile, setShowEditProfile] = useState(false);
  const [showEditProfileNew, setShowEditProfileNew] = useState(false);
  const [showEditA, setShowEditA] = useState(false);
  const [showEditB, setShowEditB] = useState(false);
  const [showEditC, setShowEditC] = useState(false);
  const [showEditD, setShowEditD] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [fullName, setFullName] = useState("");
  const [fullLastName, setFullLastName] = useState("");
  const [cin, setCin] = useState("");
  const [indType, setIndType] = useState("");
  const [orgName, setOrgName] = useState("");
  const [title, setTitle] = useState("");
  const [imgLogo, setImgLogo] = useState("");
  const [regId, setRegId] = useState("");
  const [chartData, setChartData] = useState([]);
  const [jobPostTimeline, setJobPostTimline] = useState([]);
  const [orgType, setOrgType] = useState("");
  const [orgSector, setOrgSector] = useState("");
  const [cmp, setCmp] = useState("");
  const [logo, setLogo] = useState("");
  const [view, setView] = useState(true);
  const [rowData, setRowData] = useState({});
  const [editImg, setEditImg] = useState(false);
  const [imgNew, setImgNew] = useState("");
  const [recentPost, setRecentPosts] = useState([]);
  const [chartsOptions, setChatsOptions] = useState([{ label: "All", value: "" }]);
  const [selectdd, setSelectDD] = useState("");
  const [count, setCount] = useState(0);
  const dummyChart = {
    labels: ["Interviews Scheduleld", "Candidates Connected"],
    datasets: {
      label: ["Interviews Scheduleld", "Candidates Connected"],
      // backgroundColors: [
      //   res.data["chart_list"][0].count === 0 ? "success" : "success",
      //   res.data["chart_list"][1].count === 0 ? "info" : "info",
      //   res.data["chart_list"][2].count === 0 ? "secondary" : "secondary",
      // ],
      backgroundColors: ["success", "info"],
      // data: res.data["chart_list"].map((ele, i) => ele.count),
      data: [10, 20],
    },
  };

  const jpDetailsNew = async () => {
    try {
      const res = await axios.get(
        // `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/account/v1/register`,
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/superadmin/register/channelpartner/register`,
        {
          params: {
            cpid: cpId,
          },
        }
      );
      console.log(res, "www");
      console.log(res.data["Developer Message"], "www");
      //setImgLogo(res?.data?.JobProvider_Detail?.org_logo);
      setImgNew(res?.data?.["Developer Message"]?.org_logo);
      setDetails(res.data["Developer Message"]);
      setFullName(res?.data?.["Developer Message"]?.firstnm);
      setFullLastName(res?.data?.["Developer Message"]?.lastnm);
      setPhone(res?.data?.["Developer Message"]?.mobnum?.slice(2));
      setEmail(res?.data?.["Developer Message"]?.email);
      setCin(res?.data?.["Developer Message"]?.org_cin_num);
      // setOrgType(res?.data?.["Developer Message"]?.org_type);
      setOrgName(res?.data?.["Developer Message"]?.org_name);
      setOrgSector(res?.data?.["Developer Message"]?.org_sector);
      setCmp(res?.data?.["Developer Message"]?.org_info);
      setRegId(res?.data?.["Developer Message"]?.registration_id);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    jpDetailsNew();
  }, []);

  console.log(imgNew, "pqw");

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    console.log("img ", file);
    //setEditImg(true);
    // if (file?.size / 1024 < 5120) {
      // setImgLogo(file);
      EditProfileLogo(file)
    // } else {
      console.log("Error");
      //ref.current.value = "";
      setImgLogo("");
    // }
  };



  const EditProfileLogo = async (e) => {
    // if (imgLogo === "") {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Please upload image < 5mb",
    //     showConfirmButton: false,
    //     timer: 1500,
    //   }).then(() => {
    //     setEditImg(false);
    //     setImgLogo("");
    //   });
    // } else {
      setEditImg(false);
      let formData = new FormData();
      formData.append("org_logo", e.target.files[0]), formData.append("cp_id", regId);
      await axios
        .post(
          `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/update/image`,
          formData
        )
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: res?.data["Developer Message"]
              ? res?.data["Developer Message"]
              : "Image uploaded successfully!",
            showConfirmButton: false,
            timer: 1500,
          })
          // .then(() => {
          //   jpDetailsNew();
          // });
          window.location.reload(false)
        })
        .catch((err) => {
          setEditImg(false);
          Swal.fire({
            icon: "error",
            title: err?.response?.data["Developer Message"]
              ? err?.response?.data["Developer Message"]
              : "Error",
            text: err?.response?.data["User Message"]
              ? err?.response?.data["User Message"]
              : "Something went wrong!",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    // }
  };

  const EditProfile = async () => {
    if (fullName === "" || fullLastName === "" || phone === "") {
      Swal.fire({
        icon: "error",
        title: "Fill all mandatory fields",
        html: `<p style='font-family:Poppins'>(marked with <span style='color:red'>*</span>)</p>`,
        showConfirmButton: false,
        timer: 1500,
      });
      setFullName(details.firstnm);
      setFullLastName(details.lastnm);
      setPhone(details.mobnum.substring(2));
    } else {
      setEditImg(false);
      let formdata = new FormData();
      console.log("img:", imgLogo);
      formdata.append("cp_id", regId);
      formdata.append("updatedby", regId);
      formdata.append("email", email);
      formdata.append("mobnum", phone);
      formdata.append("firstnm", fullName);
      formdata.append("lastnm", fullLastName);
      formdata.append("org_cin_num", cin);
      formdata.append("org_type", orgType);
      formdata.append("org_name", orgName);
      formdata.append("org_info", cmp);
      formdata.append("org_sector", orgSector);
      formdata.append("security_ques", details.security_ques);
      formdata.append("security_ans", details.security_ans);
      await axios
        .patch(
          `${process.env.REACT_APP_BACKEND_GENERIC_URL}/superadmin/register/channelpartner/register`,
          formdata
        )
        .then((res) => {
            sessionStorage.setItem("user_name", `${fullName} ${fullLastName}`);
          Swal.fire({
            //position: "top",
            icon: "success",
            title: res?.data["User Message"] ? res?.data["User Message"] : "Register Successfully!",
            showConfirmButton: false,
            timer: 1500,
          });
          window.location.reload(false);
          jpDetailsNew();
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: err?.response?.data["Developer Message"]
              ? err?.response?.data["Developer Message"]
              : "Error",
            text: err?.response?.data["User Message"]
              ? err?.response?.data["User Message"]
              : "Something went wrong!",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    }
  };

  const RecentlyKPIsFunc = async () => {
    await axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/job/recent`, {
        params: {
          cpid: cpId,
        },
      })
      .then((res) => {
        console.log("recent", res.data["Developer Message"]);
        setRecentPosts(res.data["Developer Message"]);
      })
      .catch((err) => {
        console.log("recent", err);
      });
  };
  const JobPostOptionsFunc = async () => {
    await axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/job/accept`, {
        params: {
          cpid: cpId,
        },
      })
      .then((res) => {
        console.log("recent", res.data["Accepted Job"]);
        setChatsOptions(chartsOptions.concat(res.data["Accepted Job"]));
      })
      .catch((err) => {
        console.log("recent", err);
      });
  };

  const sectorOption = [
    {
      label: "Public",
      value: "Public",
    },
    {
      label: "Private",
      value: "Private",
    },
    {
      label: "PSU",
      value: "PSU",
    },
  ];

  const CapitalizeFunc = (str) => {
    const arr = str.split(" ");
    for (let i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].splice(1);
    }
    const newStr = arr.join(" ");
    return newStr;
  };
  const hiddenFileInput = useRef(null);
  
  // Programatically click the hidden file input element
  // when the Button component is clicked
  const handleClick = event => {
    console.log("mmm")
    hiddenFileInput.current.click();

  };

  const ChartsFunc = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/channelpartner/dashboard/candidate/chart`,
        {
          params: {
            cpid: cpId,
            jobid: selectdd,
            // chart: true,
          },
        }
      )
      .then(
        (res) => (
          console.log("respo", res.data),
          res.data["Chart Data"].map((ele, i) => ele.count === 0 && setCount((count) => count + 1)),
          setChartData(
            res.data["Chart Data"]?.map((v, i) => {
              return {
                id: v.id
                  ? v.id
                      ?.split(" ")
                      ?.map((v) => v?.charAt(0)?.toUpperCase() + v?.slice(1))
                      ?.join(" ")
                  : "",
                // role: `Role ${i + 1}`,
                label: v.id
                  ? v.id
                      ?.split(" ")
                      ?.map((v) => v?.charAt(0)?.toUpperCase() + v?.slice(1))
                      ?.join(" ")
                  : "",
                value: v.count,
                // color: data3.map((el) => el.fill),
                color: v.id.includes("Interview") ? "#cdb4db" : "#a2d2ff",
                percent: `${(
                  (v.count /
                    res.data["Chart Data"]?.map((v) => v.count).reduce((a, c) => a + c, 0)) *
                  100
                ).toFixed(2)}%`,
              };
            })
          )
        )
      )
      .catch((err) => console.log(err));
  };

  const stylesDD = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      // borderColor: state.isFocused ? "grey" : "red",
      fontSize: "14px",
      fontFamily: "Poppins",
      width: "250px",
    }),
    option: (base) => ({
      ...base,
      // border: `1px dotted red`,
      height: "100%",
      fontSize: "14px",
      fontFamily: "Poppins",
    }),
  };

  useEffect(() => {
    // ChartsFunc();
    RecentlyKPIsFunc();
    JobPostOptionsFunc();
  }, []);
  useEffect(() => {
    ChartsFunc();
    setCount(0);
  }, [selectdd]);
  const handleStateFunc = () => {
    setView(true);
    sessionStorage.getItem("role_access") === "Requirement Based"
      ? navigate("/jobproviderrb/all-postings")
      : navigate("/jobprovidere2e/all-postings");
    // navigate(-1);
  };

  const [searchData, setSearchData] = useState([
    {
      job_title: "Account manager",
      requirement: 10,
      job_type: "Full Time",
      state: "Maharashtra",
      workfromhome: "Yes",
    },
    {
      job_title: "Tele Caller",
      requirement: 20,
      job_type: "Full Time",
      state: "Delhi",
      workfromhome: "Yes",
    },
    {
      job_title: "Chat Support",
      requirement: 5,
      job_type: "Full Time",
      state: "Maharashtra",
      workfromhome: "No",
    },
    {
      job_title: "Customer Care",
      requirement: 10,
      job_type: "Part Time",
      state: "Maharashtra",
      workfromhome: "Hybrid",
    },
  ]);

  return (
    <>
      {/* <DashboardNavbar /> */}
      {view && (
        <DashboardLayout>
          <Grid containter spacing={2}>
            <Grid item lg={12} xs={12}>
              <BoxGrid1>
                <div className="rectangleimg">
                  <Typography
                    variant="h1"
                    sx={{
                      fontSize: matchmd ? "60px" : "37px",
                      fontWeight: 400,
                      color: "#FFFFFF",
                      fontFamily: "Mate SC",
                    }}
                  >
                    {/* Saksham Rojgar Sathi */}
                    {cpType === "Skilling Partner" ? "Training Partner" : "Saksham Rojgar Sathi"}
                  </Typography>
                </div>

                <BoxMain1>
                  <BoxMain3>
                    <label htmlFor="imgupload">
                      <BoxImg>
                        <img
                          src={imgNew}
                          alt=""
                          style={{
                            width: "160px",
                            height: "119px",
                            borderRadius: "5px",
                            border: "1px solid #C4C4C4",
                          }}
                        />

                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <img
                            src={editiconimg}
                            alt="edit"
                            height={"24"}
                            width={"24"}
                            style={{ cursor: "pointer", mt: -1 }}
                            onClick={()=>handleClick()}
                          />
                        </Box>

                        <input
                          // id="imgupload"
                          ref={hiddenFileInput}
                          style={{ display: "none" }}
                          type="file"
                          // accept=".jpg, .jpeg, .png"
                          onChange={(e) => {
                            // handleFileUpload(e);
                            EditProfileLogo(e)
                            // console.log("hit");
                            // setEditImg(true);
                          }}
                        />
                      </BoxImg>
                    </label>

                    <Box sx={{ paddingLeft: "12px", minWidth: "300px", paddingTop: "8px" }}>
                      <TypographyOrg1 variant="h3">
                        {details.org_name ? details.org_name : "NA"}
                      </TypographyOrg1>
                    </Box>
                  </BoxMain3>

                  <BoxMain2>
                    <TypographyLocation variant="h3">
                      <img src={locationicon} alt="location" height={"20.17"} width={"16.5"} />
                      &nbsp;{details.org_address ? details.org_address : "NA"}
                    </TypographyLocation>

                    {!editOne ? (
                      <img
                        src={editiconimg}
                        alt="edit"
                        height={"24"}
                        width={"24"}
                        style={{ cursor: "pointer" }}
                        onClick={() => setEditOne(true)}
                      />
                    ) : (
                      <Box sx={{ display: "flex" }}>
                        <IconButton
                          sx={{ m: 0, p: 0, ml: 0.5, mr: 0.5 }}
                          onClick={() => {
                            EditProfile();
                            setEditOne(false);
                          }}
                        >
                          <CheckCircleIcon sx={{ color: "#3B5092" }} />
                        </IconButton>

                        <IconButton
                          sx={{ m: 0, p: 0, ml: 0.5, mr: 0.5 }}
                          onClick={() => {
                            setEditOne(false);
                          }}
                        >
                          <CancelIcon sx={{ color: "#6C6C6C" }} />
                        </IconButton>
                      </Box>
                    )}
                  </BoxMain2>
                </BoxMain1>

                <BoxCompanyInfo>
                  <TypographyCompanyDes variant="h3">
                    <img src={cmpimg} height={"26px"} width={"26px"} />
                    &nbsp;
                    {cpType === "Skilling Partner"
                      ? "Training Partner Description"
                      : "SRS Description"}
                  </TypographyCompanyDes>

                  {editOne ? (
                    <SoftInput
                      multiline
                      rows={3}
                      type="text"
                      name="jobdesc"
                      id="jobdesc"
                      defaultValue={cmp}
                      inputProps={{
                        maxLength: "1000",
                      }}
                      onChange={(e) => setCmp(e.target.value)}
                    />
                  ) : (
                    <Box sx={{ height: "114px", overflow: "auto" }}>
                      <TypographyCompanyinfo variant="body1">
                        {details.org_info ? details.org_info : "NA"}
                      </TypographyCompanyinfo>
                    </Box>
                  )}

                  {editOne ? (
                    <span className="spancharacters">
                      {cmp !== null ? cmp.length : 0} of 1000 characters
                    </span>
                  ) : null}
                </BoxCompanyInfo>
                <hr />

                {/* <BoxButtonContainer> */}
                  {/* {step === 0 ? (
                    <TabButtonLeft>SPOC Details</TabButtonLeft>
                  ) : (
                    <TabButtonClickLeft onClick={() => setStep(0)}>SPOC Details</TabButtonClickLeft>
                  )} */}

                  {/* {step === 1 ? (
                    <TabButton>Placement Statistics</TabButton>
                  ) : (
                    <TabButtonClick
                      onClick={() => {
                        setStep(1);
                      }}
                    >
                      Placement Statistics
                    </TabButtonClick>
                  )} */}

                  {/* {step === 2 ? (
                    <TabButton>Recently Requested</TabButton>
                  ) : (
                    <TabButtonClick
                      onClick={() => 
                        setStep(2);
                      }}
                    >
                      Recently Requested
                    </TabButtonClick>
                  )} */}
                {/* </BoxButtonContainer> */}
              </BoxGrid1>
            </Grid>

            <Grid item lg={12} xs={12}>
              {step === 0 ? (
                <BoxGrid1>
                  <BoxHeadingContainer1>
                    <TypographyTabHeading variant="h3">
                      <img src={spocimg} height={"24px"} width={"24px"} />
                      &nbsp;SPOC Details
                    </TypographyTabHeading>

                    {!editTwo ? (
                      <img
                        src={editiconimg}
                        alt="edit"
                        height={"24"}
                        width={"24"}
                        style={{ cursor: "pointer" }}
                        onClick={() => setEditTwo(true)}
                      />
                    ) : (
                      <Box sx={{ display: "flex" }}>
                        <IconButton
                          sx={{ m: 0, p: 0, ml: 0.5, mr: 0.5 }}
                          onClick={() => {
                            setEditTwo(false);
                            EditProfile();
                          }}
                        >
                          <CheckCircleIcon sx={{ color: "#3B5092" }} />
                        </IconButton>

                        <IconButton
                          sx={{ m: 0, p: 0, ml: 0.5, mr: 0.5 }}
                          onClick={() => {
                            setEditTwo(false);
                            setFullName(details.firstnm);
                            setFullLastName(details.lastnm);
                            setPhone(details.mobnum.substring(2));
                            setEmail(details.email);
                          }}
                        >
                          <CancelIcon sx={{ color: "#6C6C6C" }} />
                        </IconButton>
                      </Box>
                    )}
                  </BoxHeadingContainer1>
                  <hr />

                  <BoxInfoContainer1>
                    <BoxHeading1>
                      <TypographyHeading1 variant="h3">
                        First Name{editTwo ? <sup style={{ color: "red" }}>*</sup> : ":"}
                      </TypographyHeading1>

                      {editTwo ? (
                        <TextField
                          type="text"
                          size="small"
                          defaultValue={fullName}
                          onChange={(e) => setFullName(e.target.value)}
                        />
                      ) : (
                        <TypographyList variant="body1">
                          &nbsp;{details.firstnm ? details.firstnm : "NA"}
                        </TypographyList>
                      )}
                    </BoxHeading1>

                    <BoxHeading1>
                      <TypographyHeading1 variant="h3">
                        Last Name{editTwo ? <sup style={{ color: "red" }}>*</sup> : ":"}
                      </TypographyHeading1>

                      {editTwo ? (
                        <TextField
                          type="text"
                          size="small"
                          defaultValue={fullLastName}
                          onChange={(e) => setFullLastName(e.target.value)}
                        />
                      ) : (
                        <TypographyList variant="body1">
                          &nbsp;{details.lastnm ? details.lastnm : "NA"}
                        </TypographyList>
                      )}
                    </BoxHeading1>

                    <BoxHeading1>
                      <TypographyHeading1 variant="h3">
                        Phone{editTwo ? <sup style={{ color: "red" }}>*</sup> : ":"}
                      </TypographyHeading1>

                      {editTwo ? (
                        <TextField
                          type="tel"
                          size="small"
                          defaultValue={phone}
                          inputProps={{
                            maxLength: "10",
                          }}
                          onChange={(e) => setPhone(e.target.value)}
                        />
                      ) : (
                        <TypographyList variant="body1">
                          &nbsp;
                          {details.mobnum
                            ? `+${details.mobnum?.substring(0, 2)}-${details.mobnum?.slice(2)}`
                            : "NA"}
                        </TypographyList>
                      )}
                    </BoxHeading1>

                    <BoxHeading1>
                      <TypographyHeading1 variant="h3">
                        Email{editTwo ? <sup style={{ color: "red" }}>*</sup> : ":"}
                      </TypographyHeading1>

                      {editTwo ? (
                        <TextField
                          type="email"
                          size="small"
                          defaultValue={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      ) : (
                        <TypographyList variant="body1">
                          &nbsp;{details.email ? details.email : "NA"}
                        </TypographyList>
                      )}
                    </BoxHeading1>
                  </BoxInfoContainer1>
                </BoxGrid1>
              ) : step === 1 ? (
                <BoxGrid1>
                  <TypographyTabHeading variant="h3">Placement Statistics</TypographyTabHeading>
                  <hr />

                  <Grid container>
                    <Grid item lg={4} md={6} sm={12} xs={12}>
                      <BoxFlex1>
                        <TypographyHeading2 variant="h3">Select Job Role</TypographyHeading2>

                        <Select
                          placeholder="View List"
                          styles={stylesDD}
                          options={chartsOptions}
                          defaultValue={selectdd === "" && { label: "All", value: "" }}
                          onChange={(e) => {
                            setSelectDD(e ? e.value : "");
                          }}
                        />
                      </BoxFlex1>

                      {count !== 2 ? (
                        <>
                          {chartData.map((v, i) => {
                            return (
                              <Box
                                key={i}
                                sx={{
                                  mt: 1,
                                  display: "flex",
                                  alignItems: "center",
                                  paddingLeft: "24px",
                                }}
                              >
                                <SquareIcon fontSize="small" sx={{ color: v.color }} />

                                <TypographyList variant="body1">&nbsp;{v.label}</TypographyList>
                              </Box>
                            );
                          })}
                        </>
                      ) : null}
                    </Grid>

                    <Grid item lg={4} md={12} sm={12} xs={12}>
                      {count !== 2 ? (
                        <div
                          style={{
                            height: "250px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <ResponsivePie
                            data={chartData}
                            margin={{
                              top: 30,
                              right: 30,
                              bottom: 30,
                              left: 30,
                            }}
                            innerRadius={0.25}
                            motionConfig="gentle"
                            transitionMode="middleAngle"
                            padAngle={1}
                            cornerRadius={1}
                            activeOuterRadiusOffset={8}
                            borderWidth={1}
                            borderColor={{
                              from: "color",
                              modifiers: [["darker", 0.2]],
                            }}
                            colors={["#a2d2ff", "#cdb4db"]}
                            enableArcLinkLabels={true}
                            arcLinkLabel={(e) => {
                              return e.data.percent;
                            }}
                            arcLinkLabelsSkipAngle={10}
                            arcLinkLabelsTextColor="#333333"
                            arcLinkLabelsThickness={2}
                            arcLinkLabelsDiagonalLength={9}
                            arcLinkLabelsStraightLength={15}
                            arcLinkLabelsColor={{ from: "color" }}
                            enableArcLabels={false}
                            arcLabelsSkipAngle={10}
                            arcLabelsTextColor={{
                              from: "color",
                              modifiers: [["darker", "3"]],
                            }}
                          />
                        </div>
                      ) : (
                        <SoftBox
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          alignItems="center"
                          mt="50px"
                          mb="75px"
                        >
                          <img src={noDataImg} width="100px" height="100px" />
                          <SoftTypography fontSize="15px" fontWeight="small" mt={1}>
                            No Data
                          </SoftTypography>
                        </SoftBox>
                      )}
                    </Grid>
                  </Grid>
                </BoxGrid1>
              ) : (
                <BoxGrid1>
                  <TypographyTabHeading variant="h3">Recently Requested</TypographyTabHeading>
                  <hr />

                  <MuiGrid container spacing={3} sx={{ p: 2 }}>
                    {recentPost?.map((item, id) => {
                      return (
                        <MuiGrid item lg={4} md={4} sm={6} xs={12} key={id}>
                          <Box
                            sx={{
                              p: 2,
                              height: "100%",
                              width: "100%",
                              background: "#FFFFFF",
                              border: "1px solid #C4C4C4",
                              borderRadius: "10px",
                            }}
                          >
                            <Box sx={{ minHeight: "200px" }}>
                              <BoxHeading1>
                                <TypographyHeading1 variant="h3">Job Role:</TypographyHeading1>

                                <TypographyList variant="body1">{item.job_title}</TypographyList>
                              </BoxHeading1>

                              <BoxHeading1>
                                <TypographyHeading1 variant="h3">
                                  No. of Position:
                                </TypographyHeading1>

                                <TypographyList variant="body1">{item.applicantct}</TypographyList>
                              </BoxHeading1>

                              <BoxHeading1>
                                <TypographyHeading1 variant="h3">Work Type:</TypographyHeading1>

                                <TypographyList variant="body1">{item.job_type}</TypographyList>
                              </BoxHeading1>

                              <BoxHeading1>
                                <TypographyHeading1 variant="h3">Location:</TypographyHeading1>

                                <TypographyList variant="body1">{item.state}</TypographyList>
                              </BoxHeading1>

                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "self-end",
                                  height: "50px",
                                  bottom: "0px",
                                  mt: -3,
                                }}
                              >
                                <Box sx={{ background: "#9E00FF", p: 1, borderRadius: "6px" }}>
                                  <Typography
                                    variant="body1"
                                    sx={{
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "16px",
                                      lineHeight: "26px",
                                      color: "#FFFFFF",
                                    }}
                                  >
                                    {item.workfromhome === "Yes"
                                      ? "WFH"
                                      : item.workfromhome === "No"
                                      ? "WFO"
                                      : "Hybrid"}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </MuiGrid>
                      );
                    })}
                  </MuiGrid>
                </BoxGrid1>
              )}
            </Grid>
          </Grid>
          <Box></Box>
        </DashboardLayout>
      )}
      {!view && (
        <PostProfile
          rowData={rowData}
          state={view}
          setView={setView}
          buttonFunc={handleStateFunc}
        />
      )}
    </>
  );
};
ProfilePage.propTypes = {
  state: PropTypes.bool.isRequired,
  handleFunc: PropTypes.func.isRequired,
};
export default ProfilePage;
